module.exports = __webpack_public_path__ + "img/logo.4f6c04b3.png";